import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Puntos Básicos del Crochet — 10 Clases para Principiantes',
    description: '10 videoclases esenciales para dominar los puntos básicos desde cero. Ideal si estás empezando o quieres reforzar tu técnica.',
    image: 'https://cdn.magicpatterns.com/uploads/8eBphebzPUCg7jTzvLL3Es/20260225_2105_Image_Generation_simple_compose_01kjbm6w0cez2tkqqk6089akah.png',
    tag: 'Para principiantes',
    fakePrice: '$19.99'
  }, {
    title: 'Cómo Vender Amigurumis Personalizados y Cobrar Precio Premium',
    description: 'Guía para emprendedoras: aprende a ofrecer mascotas por raza como servicio exclusivo y diferenciarte del resto.',
    image: 'https://cdn.magicpatterns.com/uploads/xeX1WzteNitxvnS5nyFXao/20260225_1949_Image_Generation_remix_01kjbfvz9rfqx9wh28p8h1m735.png',
    tag: 'Para emprendedoras',
    fakePrice: '$14.99'
  }, {
    title: 'Pack Amigos de Kitty',
    description: 'Colección especial de patrones inspirados en los personajes más tiernos. Perfectos para regalar o vender.',
    image: 'https://cdn.magicpatterns.com/uploads/vTiubZGPogNZWQUUX4wQGQ/20260225_1949_Image_Generation_remix_01kjbfve3aebnvs15r2wfb0nht.png',
    tag: 'Patrones extra',
    fakePrice: '$12.99'
  }, {
    title: 'Patrones Gatitos Halloween',
    description: 'Gatitos con temática de Halloween: calabazas, brujitas y fantasmitas. Ideales para temporada.',
    image: 'https://cdn.magicpatterns.com/uploads/pJVUjm8jXJYYabGZR48rRw/20260225_1949_Image_Generation_remix_01kjbftmr7fw28z5cktr40bdea.png',
    tag: 'Edición especial',
    fakePrice: '$9.99'
  }, {
    title: 'Gatitos Cactus',
    description: 'La combinación más adorable: gatitos disfrazados de cactus. Un diseño único que encanta a todos.',
    image: 'https://cdn.magicpatterns.com/uploads/pSK6XVACehszdNjVPCWT4s/20260225_1948_Image_Generation_remix_01kjbfshcsfbztfch36est4249.png',
    tag: 'Edición especial',
    fakePrice: '$9.99'
  }];
  return <section className="py-10 md:py-16 bg-white" data-id="element-15">
      <div className="max-w-5xl mx-auto px-4" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-17">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cream rounded-full mb-5" data-id="element-18">
            <Gift size={16} className="text-copper" data-id="element-19" />
            <span className="text-sm font-bold text-copper" data-id="element-20">
              5 Bonos incluidos
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown mb-3" data-id="element-21">
            Y además, te llevas estos regalos
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto" data-id="element-22">
            Bonos exclusivos que complementan tu colección y te dan aún más
            valor.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`etsy-card etsy-card-hover overflow-hidden ${index === 0 ? 'md:col-span-2' : ''}`} data-id="element-24">
              <div className={`${index === 0 ? 'md:flex' : ''}`} data-id="element-25">
                {/* Image */}
                <div className={`relative ${index === 0 ? 'md:w-1/2' : ''}`} data-id="element-26">
                  <img src={bonus.image} alt={bonus.title} className={`w-full ${index === 0 ? 'aspect-video md:aspect-auto md:h-full' : 'aspect-video'} object-cover`} data-id="element-27" />
                  <div className="absolute top-3 left-3" data-id="element-28">
                    <span className="text-[10px] font-bold uppercase tracking-wider bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full text-copper shadow-sm" data-id="element-29">
                      {bonus.tag}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className={`p-5 ${index === 0 ? 'md:w-1/2 md:flex md:flex-col md:justify-center' : ''}`} data-id="element-30">
                  <div className="flex justify-between items-start mb-2" data-id="element-31">
                    <h3 className="font-bold text-deep-brown leading-snug flex-1 pr-2" data-id="element-32">
                      {bonus.title}
                    </h3>
                    <div className="flex flex-col items-end" data-id="element-33">
                      <span className="text-xs text-gray-400 line-through" data-id="element-34">
                        {bonus.fakePrice}
                      </span>
                      <span className="text-xs font-bold text-teal bg-teal/10 px-2 py-0.5 rounded-full" data-id="element-35">
                        HOY GRATIS
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed" data-id="element-36">
                    {bonus.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-linen rounded-xl p-6 text-center border border-copper/20" data-id="element-37">
          <p className="text-deep-brown font-bold text-lg" data-id="element-38">
            Valor total de los bonos:{' '}
            <span className="line-through text-gray-400" data-id="element-39">$67.95</span>{' '}
            <span className="text-copper" data-id="element-40">→ HOY INCLUIDOS GRATIS</span>
          </p>
        </motion.div>
      </div>
    </section>;
}